export default __webpack_public_path__ + "static/media/logo-initials-md.9e646349.jpg";